import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export const NAVI_INTER_KEY = "ict24h-navi-inter";

/**
 * Hàm xác định route module iframe tương ứng dựa trên đường dẫn target
 */
export const getDestinationModuleRoute = (targetTo: string, moduleParam?: string | null): string => {
  if (moduleParam && moduleParam.trim() !== "") {
    return `/ext/${moduleParam.trim()}`;
  }
  if (targetTo.startsWith("/ext/")) {
    return targetTo;
  }
  if (
    targetTo.startsWith("/quan-ly-phe-duyet") ||
    targetTo.startsWith("/e-office")
  ) {
    return "/ext/office-task";
  }
  if (targetTo.startsWith("/pms")) {
    return "/ext/cenprecast-pms";
  }
  if (targetTo.startsWith("/hrm")) {
    return "/ext/hrm-my-profile";
  }
  return "/ext/default";
};

const NaviInter: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const toParam = searchParams.get("to");
    const moduleParam = searchParams.get("module");

    if (toParam && toParam.trim() !== "") {
      const targetTo = toParam.trim();
      console.log(`[NaviInter] Lưu ${NAVI_INTER_KEY}:`, targetTo);
      localStorage.setItem(NAVI_INTER_KEY, targetTo);

      const destination = getDestinationModuleRoute(targetTo, moduleParam);

      console.log(`[NaviInter] Điều hướng tới module:`, destination);
      // Sử dụng replace: true để xóa query param khỏi lịch sử trình duyệt, tránh loop redirect
      navigate(destination, { replace: true });
    } else {
      console.warn("[NaviInter] Tham số 'to' không hợp lệ.");
      navigate("/home", { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: "48px", textAlign: "center" }}>
      <h3>Đang xử lý điều hướng nội bộ (Navi-Inter)...</h3>
    </div>
  );
};

export default NaviInter;
